export default __webpack_public_path__ + "static/media/fund-info.4a7de74d.svg";